import { observable, computed, action } from 'mobx';

export class Tooltip {
  @observable place;
  @observable prevPlace;
}

const t = new Tooltip();
export default t;
